module.exports = __webpack_public_path__ + "pc/static/img/act.153acef2.png";